import React from 'react';
import { articleMeta } from '../data/article';
export function HeroImage() {
  return <figure className="mt-10 max-w-[560px]" data-id="element-48" data-mp="slms3tywewt2">
      <img src={articleMeta.heroImage} alt="Don Callaway standing in front of a red Ferrari on a cobblestone street" className="w-full" loading="eager" data-id="element-49" data-mp="skbt07geed8a" />
      <figcaption className="mt-3 border-t border-rule pt-3" data-id="element-50" data-mp="12ael85fp3n5k">
        <span className="font-sans text-[13px] text-ink-soft" data-id="element-51" data-mp="4oh52eosftws">{articleMeta.heroCaption}</span>
        <span className="ml-3 font-sans text-[11px] uppercase tracking-[0.1em] text-ink-faint" data-id="element-52" data-mp="9msdqm3cjydf">
          {articleMeta.heroCredit}
        </span>
      </figcaption>
    </figure>;
}